export default { sha: '30599c9718ad721012f381dc721008118cea6cc9', buildNumber: 'undefined' }
